import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

// Keyframes for scrolling animation
const scroll = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const logos = [
  "https://upload.wikimedia.org/wikipedia/commons/c/c3/Bosch_logo.png",
  "https://www.tvsmotor.com/-/media/Feature/Header/TVSLogo-hr.svg",
  "https://www.lumaxworld.in/images/main-logo.svg",
  "https://www.tvh.com/sites/tvh/files/2022-09/logo_LuK_web_500x300%20%281%29_1.png",
  "https://www.equitybulls.com/equitybullsadmin/uploads/Gabriel%20India%20Limited%20Logo%202.jpg",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Brembo_logo_%282022%29.svg/2560px-Brembo_logo_%282022%29.svg.png",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Purolator_Logo.svg/2560px-Purolator_Logo.svg.png",
  "https://upload.wikimedia.org/wikipedia/en/thumb/e/e8/Shell_logo.svg/1280px-Shell_logo.svg.png",
  "https://www.lumaxworld.in/images/main-logo.svg",
  "https://www.mobil.com/lubricants/-/media/feature/wep/wep-navigation/mobil-tm-logo.png?h=168&iar=0&w=590&hash=0A2C452F24DBEBE6056118D16592A946",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Denso_logo.svg/450px-Denso_logo.svg.png",
  "https://cms.hiq.co.za/media/logo.png",
  "https://www.valeo.com/wp-content/themes/valeo/images/logo.png",
];

const Marquee = () => {
  return (
    <>
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: "bold",
          color: "#4a4a4a",
          marginBottom: "20px",
        }}
      >
        Our Working Partners
      </Typography>
      <Box
        sx={{
          display: "flex",
          overflow: "hidden",
          whiteSpace: "nowrap",
          // background: 'linear-gradient(to right, #e0eafc, #cfdef3)', // Subtle gradient
          padding: "20px 0",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            animation: `${scroll} 30s linear infinite`,
            alignItems: "center",
          }}
        >
          {logos.map((logo, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 30px",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            >
              <img
                src={logo}
                alt={`brand-logo-${index}`}
                style={{
                  height: "60px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default Marquee;
